import type {Point} from 'highcharts';

import {TableColumnType} from 'common/components/data-table/types';
import {SectionItem} from 'common/components/items-menu/types';

export type PopoverCallback = (
  segment: string,
  path?: string[],
  options?: {highchartsPointContext?: Point; forSegmentColumn?: boolean},
) => SectionItem[];

export type PopoverActionCallback = (options: {
  segment: string[];
  action: string;
  isTimeComparisonSegment?: boolean;
  color?: string | null;
  columnIndex?: number;
  columnType?: TableColumnType;
}) => void;

export enum PopoverOption {
  Exclude = `exclude`,
  Filter = `filter`,
  ViewEvents = `view_events`,
  ViewUsers = `view_users`,
  ZoomIn = `zoom_in`,
  RCA = `rca`,
}
